import React, { useState, useEffect } from "react";
import TableScaleModel from "../../../../components/lists/scaleModelList/index";
import MenuAdmin from "../../../../components/layout/menu";
import ResetFiltersButton from "../../../../components/filters/resetFiltersButton/index";
import FilterButton from "../../../../components/filters/filterButton/index";
import SearchInput from "../../../../components/filters/searchInput/index";
import ExportButton from "../../../../components/shared/exportButton";
import { getScaleModel } from "../../../../client/administration/scaleModel";
import * as XLSX from 'xlsx';
import {  RiAddFill } from "react-icons/ri";
import ContentLoader from 'react-content-loader'; // Importamos el ContentLoader
import Programate from "../../../../components/layout/footer";

const ScaleModel = () => {
  const [currentRecordsCount, setCurrentRecordsCount] = useState(10);
  const [currentPage, setCurrentPage] = useState(1); 

  const [modelName, setModelName] = useState("");  
  const [brandName, setBrandName] = useState([]);
  const [selectedBrandName, setSelectedBrandName] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true); // Estado de carga

  const [showModalAddScale, setShowModalAddScale] = useState(false);

  const openModalAddScale = () => {
    setShowModalAddScale(true);
  };

  const closeModalAddScale = () => {
    setShowModalAddScale(false);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);  

    useEffect(() => {
      const fetchScaleModels = async () => {
        try {
          const response = await getScaleModel();
         // console.log("Registros obtenidos:", response.data); // Verifica los registros obtenidos

          setRecords(response.data);
          setFilteredRecords(response.data);
          const uniqueBrandNames = [...new Set(response.data.map(record =>
            record.scaleBrand &&
            record.scaleBrand.brandName))];
          setBrandName(uniqueBrandNames);
        } catch (error) {
          console.error('Error fetching scales:', error);
        } finally {
          setLoading(false); // Detener el loading después de obtener los datos
        }
      };
  
      fetchScaleModels();
    }, []);
  
  // Función para manejar el filtro por nombre de marca
  const handleFilterByBrand = (brandName) => {
    setSelectedBrandName(brandName);
    const filtered = records.filter(record =>
      record.scaleBrand &&
      record.scaleBrand.brandName && record.scaleBrand.brandName.includes(brandName));
    setFilteredRecords(filtered);
  };
  
  // Función para restablecer los filtros
  const handleResetFilters = () => {
    setModelName(""); 
    setBrandName(""); 
    setSearchTerm("");
    setSelectedBrandName("");
  };

  const handleSearch = (value) => {
    setSearchTerm(value); // Actualiza el estado del término de búsqueda
    const lowerCaseValue = value.toLowerCase(); // Convierte el valor a minúsculas para comparación
  
    const filtered = records.filter(record => {
      const brandMatches = record.scaleBrand && record.scaleBrand.brandName.toLowerCase().includes(lowerCaseValue);
      const modelMatches = record.modelName.toLowerCase().includes(lowerCaseValue);
      const minCapacityMatches = record.minimunCapacity.toString().includes(value);
      const maxCapacityMatches = record.maximunCapacity.toString().includes(value);
  
      return brandMatches || modelMatches || minCapacityMatches || maxCapacityMatches;
    });
  
    setFilteredRecords(filtered);
  };


  const handleExportToExcel = () => {
    const exportData = records.map(record => ({
      id: String(record.id),
      Modelo: record.modelName,
      CapacidadMax: String(record.maximunCapacity), // Convertir a cadena
      CapacidadMin: String(record.minimunCapacity),
      Marca: record.scaleBrand.brandName,
      FechaRegistro: new Date(record.createdAt).toLocaleString()
    }));
  
    const ws = XLSX.utils.json_to_sheet(exportData);
  
    // títulos de las columnas
    ws['A1'].v = 'ID';
    ws['B1'].v = 'Modelo';
    ws['C1'].v = 'Capacidad Max';
    ws['D1'].v = 'Capacidad Min';
    ws['E1'].v = 'Marca';
    ws['F1'].v = 'Fecha Registro';
  
    for (let i = 2; i <= exportData.length + 1; i++) {
      ws[`A${i}`].s = { alignment: { horizontal: "left" } };
      ws[`B${i}`].s = { alignment: { horizontal: "left" } };
      ws[`C${i}`].s = { alignment: { horizontal: "left" } };
      ws[`D${i}`].s = { alignment: { horizontal: "left" } };
      ws[`E${i}`].s = { alignment: { horizontal: "left" } };
      ws[`F${i}`].s = { alignment: { horizontal: "left" } };
    }
    //  ancho de las columnas
    ws['!cols'] = [
      { wch: 10 }, //  (ID)
      { wch: 20 }, //  (Modelo)
      { wch: 15 }, //  (Cap max)
      { wch: 15 }, //  (Cap min)
      { wch: 15 }, //  (Marca)
      { wch: 25 }, //  (Fecha registro)

    ];
  
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Modelo-balanzas");
  
    XLSX.writeFile(wb, "modelo-balanzas.xlsx");
  };

  const handleRecordsCountChange = (event) => {
    const newCount = parseInt(event.target.value, 10);
    setCurrentRecordsCount(newCount); // Actualiza el número de registros por página
    setCurrentPage(1); // Reinicia a la primera página
  };

  const isExportDisabled = filteredRecords.length === 0; 


  return (
    <div className="flex w-full min-h-screen ">
      <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[220px] sm:ml-[0] md:ml-[0]" : "ml-0"} w-[83%] `}>
        <div className="flex flex-col justify-between min-h-screen">
          <div className="  pb-12 px-[3%] ">
            {loading ? (
              <div className="pt-32 pb-8 -space-y-2 sm:-space-y-20">
                {/* Skeleton para el título */}
                <ContentLoader
                  viewBox="0 0 1200 200"
                  height="100%"
                  width="100%"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={5}
                >
                  <rect x="0" y="0" width="30%" height="40" rx="5" ry="5" /> {/* Título "Modelo de Balanzas" */}
                  <rect x="0" y="60" width="23%" height="40" rx="5" ry="5" /> {/* Filtro por marcas */}    
                  <rect x="0" y="120" width="23%" height="40" rx="5" ry="5" /> {/* Botón "Agregar modelo de balanza" */}
                  <rect x="76%" y="60" width="13%" height="40" rx="5" ry="5" /> {/* Botón "Reset" */}
                  <rect x="90%" y="60" width="10%" height="40" rx="5" ry="5" /> {/* Botón "Exportar" */}
                  <rect x="76%" y="120" width="25%" height="40" rx="5" ry="5" /> {/* Barra de búsqueda */}
                </ContentLoader>
    
                {/* Skeleton para la tabla */}
                <ContentLoader
                  width="100%"
                  height="100%"
                  viewBox="0 0 1500 400"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={5}
                >
                   {/* Columnas de la tabla */}
                  <rect x="0%" y="139" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="140" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="141" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="142" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="143" rx="10" ry="10" width="12%" height="19" />
    
                  <rect x="0%" y="196" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="197" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="198" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="197" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="198" rx="10" ry="10" width="12%" height="19" />
              
                  <rect x="0%" y="258" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="259" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="260" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="259" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="260" rx="10" ry="10" width="12%" height="19" />
              
                  <rect x="0%" y="316" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="317" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="318" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="317" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="318" rx="10" ry="10" width="12%" height="19" />
                </ContentLoader>
              </div>
            ) : (
              <div className="pt-28 md:pt-28 lg:pt-28 2xl:pt-[7rem]">
                <p className="text-[32px] font-itcbold text-[#007696] text-center lg:text-left ">Modelo de Balanzas</p>
    
                <div className="flex flex-col items-start justify-center">
                  {/* Filtros */}
                  <div className="flex flex-col-reverse items-start justify-between w-full gap-2 pt-4 md:pt-0 md:items-center md:flex-row ">
                    <div className="flex items-center mb-4 md:my-4 md:space-y-5">
                      <FilterButton
                        text="Filtrar por marcas"
                        options={brandName}
                        onSelect={handleFilterByBrand} 
                        selectedOption={selectedBrandName}
                      />
                    </div>
                    <div className="flex flex-row items-center justify-between w-full space-y-5 md:gap-2 md:justify-end md:space-y-0 lg:space-x-5 ">
                          
                    <SearchInput 
                      placeholder='Buscar' 
                      value={searchTerm}
                      onChange={handleSearch}
                    />  

                    </div> 
                  </div>
    
                  <div className="flex flex-col-reverse items-start w-full gap-5 mb-4 lg:gap-0 md:justify-between md:items-center md:flex-row ">
                    {/** 
                    <div className="flex items-center justify-center space-x-2">
                      <p className="text-sm text-[#76A140] font-itcbook">Mostrar</p>
                      <div className="border-[#76A140] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                        <select
                          className="text-sm text-[#76A140] font-itcbook px-2 w-full h-full bg-white rounded-md outline-none"
                          value={currentRecordsCount}
                          onChange={handleRecordsCountChange}  
                        >
                          <option value={10}>10</option>
                          <option value={15}>15</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                        </select>
                      </div>
                      <p className="text-sm text-[#76A140] font-itcbook">Registros</p>
                    </div>
                    */}
                    <div className="flex items-center justify-center w-full md:justify-start">
                      <button
                        onClick={openModalAddScale}
                        className="flex items-center justify-center h-[40px] p-3 px-5 space-x-4 text-white rounded-md bg-green"
                      >
                        <RiAddFill className="flex text-[14px] font-itcmedium" /> 
                          Agregar modelo de balanza
                      </button>
                    </div>

                    <div className="flex items-center justify-between w-full gap-2 md:justify-end ">
                      <ResetFiltersButton 
                            onClick={handleResetFilters}
                            /> 
                            <ExportButton onClick={handleExportToExcel}  disabled={isExportDisabled}/> 
</div> 
                    

                  </div> 
                  <TableScaleModel
                    data={records}
                    filterModelName = {modelName}
                    filterBrandName={selectedBrandName}
                    onFilterModeNameChange={setModelName}
                    onFilterBrandNameChange={setSelectedBrandName}
                    recordsPerPage={currentRecordsCount}  
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    searchTerm={searchTerm}
                    onSearchTermChange={handleSearch}
                    showModalAddScale={showModalAddScale}
                    closeModalAddScale={closeModalAddScale}
                  />
                </div>
              </div>
            )}
          </div>
          <Programate/>
        </div>
      </div>            
    </div> 
  );
};

export default ScaleModel;